import React, { useEffect } from "react"
import tw from "twin.macro"
import Fade from "react-reveal/Fade"

// commponent imports

// image imports
import circleBlue from "../../images/shapes/geo-circle-blue.svg"
import circleWhite from "../../images/shapes/geo-circle-white.svg"
import circleYellow from "../../images/shapes/geo-circle-yellow.svg"
import squareBlue from "../../images/shapes/geo-square-blue.svg"
import squareBlueBL from "../../images/shapes/geo-square-blue-bl.svg"
import squareYellowTL from "../../images/shapes/geo-square-yellow-tl.svg"
import squareYellowTLCurved from "../../images/shapes/geo-square-yellow-tl-curved.svg"
import squareWhiteTL from "../../images/shapes/geo-square-white-tl.svg"
import triangleBlueBR from "../../images/shapes/geo-triangle-blue-br.svg"
import triangleYellowBR from "../../images/shapes/geo-triangle-yellow-br.svg"
import triangleYellowTL from "../../images/shapes/geo-triangle-yellow-tl.svg"
import triangleBlueTL from "../../images/shapes/geo-triangle-blue-tl.svg"
import triangleWhiteTL from "../../images/shapes/geo-triangle-white-tl.svg"
import triangleWhiteBR from "../../images/shapes/geo-triangle-white-br.svg"
import squareWhiteBL from "../../images/shapes/geo-square-white-bl.svg"

const HeroTitle = ({ iconNames, title, variant }) => {
  const icons = {
    circleBlue: circleBlue,
    circleWhite: circleWhite,
    circleYellow: circleYellow,
    squareBlue: squareBlue,
    squareBlueBL: squareBlueBL,
    squareYellowTL: squareYellowTL,
    squareYellowTLCurved: squareYellowTLCurved,
    triangleBlueBR: triangleBlueBR,
    triangleYellowBR: triangleYellowBR,
    triangleYellowTL: triangleYellowTL,
    triangleBlueTL: triangleBlueTL,
    triangleWhiteTL: triangleWhiteTL,
    triangleWhiteBR: triangleWhiteBR,
    squareWhiteBL: squareWhiteBL,
    squareWhiteTL: squareWhiteTL
  }

  const IconImg = tw.img`pr-1 w-6 h-6 md:(pr-2 w-auto h-auto)`
  const specialStyles = {
    triangleBlueBR: tw`pr-1 w-6 h-6 md:(pr-2 mt-0.5 w-auto h-auto)`,
    triangleWhiteBR: tw`lg:mt-[1px] transform scale-105`,
    squareYellowTLCurved: tw`lg:mt-[1px] transform scale-110`,
  }

  return (
    <div tw="flex text-sm pb-4 w-full pt-5 lg:(pt-10)">
      {iconNames && (
        <Fade left>
          {iconNames.map((name, index) => (
            <IconImg
              css={[specialStyles[name] && specialStyles[name]]}
              src={icons[name]}
              key={`icon-img-${index}`}
              alt=""
            />
          ))}
        </Fade>
      )}
      <h1 tabIndex="-1" style={{textShadow: "0.5px 0.5px black", fontWeight: '600'}} css={[tw`my-auto text-blue`, iconNames && tw`ml-2`, variant==="howitmayhelp" && tw`text-white`, variant === "workdifferetly" && tw`text-white`, variant === "side-effects" && tw`text-white`, variant === "on-my-side" && tw`text-white`, variant === "connect-with-provider" && tw`text-white`]} >
        {title}
      </h1>
    </div>
  )
}

export default HeroTitle
